import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';
import { cn } from 'utils/cn';
import { AnimatedLoader } from '../AnimatedLoader';

const overlayVariants = cva(
  'absolute inset-0 z-50 flex flex-col gap-2 justify-center items-center backdrop-blur-[4px]',
  {
    variants: {
      variant: {
        light: 'bg-background bg-opacity-80',
        dark: 'bg-black bg-opacity-50',
      },
    },
    defaultVariants: {
      variant: 'light',
    },
  }
);

type OverlayVariantsProps = VariantProps<typeof overlayVariants>;

interface DataStateOverlayProps
  extends React.HTMLAttributes<HTMLDivElement>,
  OverlayVariantsProps {
  visible: boolean;
  size?: number;
  text?: string;
}

function DataStateOverlay({
  className,
  variant,
  visible,
  size = 60,
  text,
  ...props
}: DataStateOverlayProps) {
  if (!visible) return null;

  return (
    <div
      className={cn(
        overlayVariants({ variant }),
        'transition-opacity duration-500',
        className
      )}
      {...props}
    >
      <AnimatedLoader size={size} />
      {text && <span className="mt-2 text-sm text-textcolor">{text}</span>}
    </div>
  );
}

export { DataStateOverlay };
export type { DataStateOverlayProps };

